import React from 'react';
import { DynamicDashboard } from '@/shared/components/dashboard';
import { useAuth } from '@/features/auth/hooks/useAuth';

export const FiliereDashboard: React.FC = () => {
  const { user } = useAuth();

  return (
    <DynamicDashboard
      title={`Bienvenue, ${user?.firstName}`}
    />
  );
};
